import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}`;

export default {
  list(params = {}) {
    return axios.get(`${API_URL}employee/schedules`, {
      params,
      headers: buildHeaders(),
    });
  },
};
